module.exports = __webpack_public_path__ + "static/media/mason.f01631fe.png";